import React, { useState } from "react";
import { Box, Button, IconButton, Drawer } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import "./leftSideBar.scss";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { adminRoutes } from "../../routes/routeConstants";

const LeftSideBar = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const isLinkDisabled = true; // replace with your actual condition

  return (
    <>
      {localStorage.userRole === "administrator" && (
        <Box>
          <IconButton onClick={handleDrawerOpen} className="margin-left-auto">
            <MenuIcon />
          </IconButton>
          <Drawer
            anchor="left"
            className="drawer-sidebar"
            open={openDrawer}
            onClose={handleDrawerClose}
          >
            <Box className="Sidebar-add">
              <Box className="sidebar-icon-wrapper">
                <IconButton fontSize="large" onClick={handleDrawerClose}>
                  {/* <MenuIcon /> */}
                  <ChevronLeftIcon />
                </IconButton>
              </Box>
              <Box className="List-side-bar">
                {/* <Link className="sidebar-link" to={"/list-directory"}> */}
                <Link
                  className="sidebar-link"
                  to={`/${adminRoutes.listDirectory}`}
                >
                  <Button
                    key="three"
                    className={
                      // window.location.pathname === "/list-directory" ||
                      window.location.pathname === 
                        `/${adminRoutes.listDirectory}` ||
                      // window.location.pathname === "/upload-batch" ||
                      // window.location.pathname === "/upload-batch" ||
                      window.location.pathname === 
                        `/${adminRoutes.uploadBatch}` ||
                      window.location.pathname === 
                        // "/review-batch-records-details"
                        `/${adminRoutes.reviewBatchRecordDetails}`
                        ? "btn-sidebar-active"
                        : "btn-sidebar"
                    }
                  >
                    Upload PDF
                  </Button>
                </Link>

                {/* <Link className="sidebar-link" to="/output-list"> */}
                <Link
                  className="sidebar-link"
                  to={`/${adminRoutes.outputList}`}
                >
                  <Button
                    key="five"
                    className={
                      window.location.pathname === `/${adminRoutes.outputList}`
                        ? "btn-sidebar-active"
                        : "btn-sidebar"
                    }
                  >
                    Manage O/P Files
                  </Button>
                </Link>
                <Link
                  className="sidebar-link"
                  //  to="/merge-op-files"
                  to={`/${adminRoutes.mergeOpFiles}`}
                >
                  <Button
                    key="five"
                    className={
                      // window.location.pathname === "/merge-op-files" ||
                      // window.location.pathname === "/merge-op-files"
                      window.location.pathname === `/${adminRoutes.mergeOpFiles}`
                        ? "btn-sidebar-active"
                        : "btn-sidebar"
                    }
                  >
                    Merge O/P Files
                  </Button>
                </Link>

                <Link
                  className="sidebar-link"
                  // to="/manage-user"
                  to={`/${adminRoutes.manageUser}`}
                >
                  <Button
                    key="five"
                    className={
                      // window.location.pathname === "/user-form" ||
                      // window.location.pathname === "/manage-user"
                      window.location.pathname === `/${adminRoutes.userForm}` ||
                      window.location.pathname === `/${adminRoutes.manageUser}`
                        ? "btn-sidebar-active"
                        : "btn-sidebar"
                    }
                  >
                    Manage Users
                  </Button>
                </Link>
                <Link
                  className="sidebar-link"
                  // to="/batch-monitor"
                  to={`/${adminRoutes.batchMonitor}`}
                >
                  <Button
                    key="five"
                    className={
                      // window.location.pathname === "/batch-monitor"
                      window.location.pathname === `/${adminRoutes.batchMonitor}`
                        ? "btn-sidebar-active"
                        : "btn-sidebar"
                    }
                    // disabled
                  >
                    Batch Details
                  </Button>
                </Link>
                <Link
                  className="sidebar-link"
                  // to="/data-report"
                  to={`/${adminRoutes.dataReport}`}
                >
                  <Button
                    key="two"
                    className={
                      // window.location.pathname === "/data-report"
                      window.location.pathname === `/${adminRoutes.dataReport}`
                        ? "btn-sidebar-active"
                        : "btn-sidebar"
                    }
                    // disabled
                  >
                    Deletion Report
                  </Button>
                </Link>
                <Link
                  className="sidebar-link"
                  // to={"/merge-pdf"}
                  to={`/${adminRoutes.mergePdf}`}
                >
                  <Button
                    key="six"
                    className={
                      // window.location.pathname === "/merge-pdf" ||
                      // window.location.pathname === "/merge-pdf-select"
                      window.location.pathname === `/${adminRoutes.mergePdf}` ||
                      window.location.pathname === 
                        `/${adminRoutes.mergePdfSelect}`
                        ? "btn-sidebar-active"
                        : "btn-sidebar"
                    }
                    // disabled
                  >
                    Merge PDF's
                  </Button>
                </Link>

                <Link
                  className="sidebar-link"
                  // to={"/create-template"}
                  to={`/${adminRoutes.CreateTemplate}`}
                >
                  <Button
                    key="five"
                    className={
                      // window.location.pathname === "/create-template" ||
                      // window.location.pathname === "/create-template"
                      window.location.pathname === 
                      `/${adminRoutes.CreateTemplate}`
                        ? "btn-sidebar-active"
                        : "btn-sidebar"
                    }
                    // disabled
                  >
                    Create Templates
                  </Button>
                </Link>

                <Link
                  className={`sidebar-link ${
                    isLinkDisabled ? "disabled-link" : ""
                  }`}
                  to={isLinkDisabled ? "#" : `/${adminRoutes.visulization}`}
                  onClick={(e) => isLinkDisabled && e.preventDefault()}
                >
                  <Button
                    key="six"
                    className={
                      window.location.pathname ===
                      `/${adminRoutes.visulization}`
                        ? "btn-sidebar-active"
                        : "btn-sidebar"
                    }
                    disabled={isLinkDisabled}
                  >
                    Visualization
                  </Button>
                </Link>

                <Link
                  className={`sidebar-link ${
                    isLinkDisabled ? "disabled-link" : ""
                  }`}
                  to={
                    isLinkDisabled
                      ? "#"
                      : `/${adminRoutes.visualizationHistory}`
                  }
                  onClick={(e) => isLinkDisabled && e.preventDefault()}
                >
                  <Button
                    key="six"
                    className={
                      window.location.pathname ===
                      `/${adminRoutes.visualizationHistory}`
                        ? "btn-sidebar-active"
                        : "btn-sidebar"
                    }
                    disabled={isLinkDisabled}
                  >
                    Visualization Box
                  </Button>
                </Link>
              </Box>
            </Box>
          </Drawer>
        </Box>
      )}

      {/* {localStorage.userRole === "investigator" && (
        <Box className="Sidebar-add">
          <Link className="sidebar-link" to="/investigation-analysis">
            <Button
              key="one"
              className={
                window.location.pathname === "/investigation-analysis" ||
                window.location.pathname === "/investigation-analysis"
                  ? "btn-sidebar-active"
                  : "btn-sidebar"
              }
            >
              Investigation Analysis
            </Button>
          </Link>
          <Link className="sidebar-link" to="/reports">
            <Button
              key="five"
              className={
                window.location.pathname === "/reports"
                  ? "btn-sidebar-active"
                  : "btn-sidebar"
              }
            >
              Reports
            </Button>
          </Link>
        </Box>
      )} */}
    </>
  );
};

export default LeftSideBar;
